export default {
  "header.language": "語言",
  "Log in": "登入",
  "Sign Up": "註冊",
  "Buy Crypto": "買幣",
  "header.quicktrade": "快速買幣",
  "header.quicktrade.desc": "透過銀行卡快速買賣虛擬資產",
  "header.C2C": "P2P交易",
  "header.C2C.desc": "簡單操作，快速交易，開啟交易第一步",
  "header.u.account": "帳號管理",
  "header.u.fee": "我的費率",
  "header.u.bonus": "我的贈金",
  "header.u.c2c": "P2P設定",
  "header.u.invite": "邀請好友",
  "header.u.api": "API管理",
  "header.u.logout": "退出",
  "header.rate": "匯率",
  Market: "市場",
  Spot: "現貨交易",
  Futures: "合約交易",
  koltrade: "合約跟單",
  Bonus: "合約贈金",
  Agent: "全球代理人",
  more: "查看更多",
  "Perpetual Contract": "永續",
  "header.assets": "資產",
  "header.order": "訂單",
  totalAssets: "資產總覽",
  exchangeAccount: "現貨帳戶",
  otcAccount: "P2P帳戶",
  coAccount: "合約帳戶",
  exchangeOrder: "現貨訂單",
  otcOrder: "P2P訂單",
  coOrder: "合約訂單",
  "header.appDownLoad": "掃描下載APP",
  "header.moreload": "更多下載選項",
  "index.banner.2": "最懂你的AI智能交易所",
  "Register Now": "立即註冊",
  "Trade Now": "立即交易",
  "index.register.type": "信箱/手機號碼",
  "index.banner.desc": "註冊領取最高{amount}任務獎勵",
  "index.text1": "卓越的",
  "index.text2": "現貨流動性",
  "index.text3": "合約流動性",
  "index.text4": "盤口價差",
  "index.text5": "盤口厚度",
  "index.text6": "業界排名",
  "index.c4.title": "專業且易於使用",
  "index.c4.title2": "VOOX提供適合所有交易者的加密貨幣平台",
  "index.c4.t1.t": "現貨交易",
  "index.c4.t1.p": "交易BTC、ETH、USDT等主流加密貨幣，享受卓越流動性與快速執行",
  "index.c4.t2.t": "合約交易",
  "index.c4.t2.p": "透過靈活的槓桿合約交易，擴展您的交易潛力",
  "index.c4.t3.t": "跟單交易",
  "index.c4.t3.p": "跟單頂級交易員，掌握市場趨勢，輕鬆優化您的交易策略",
  "index.c5.title": "在VOOX輕鬆賺錢",
  "index.c5.title2": "在VOOX的直覺平台上解鎖加密貨幣交易的力量",
  "index.c5.t1.t": "在VOOX體驗零成本的期貨交易",
  "index.c5.t1.p":
    "透過我們豐富的贈金活動，幫助您迅速掌握合約交易，輕鬆小賺一筆",
  "index.c5.t2.t": "與高手一起智慧盈利",
  "index.c5.t2.p":
    "我們先進的跟單交易平台將您與頂尖交易者連接。只需委託，坐享其成",
  "index.c6.title": "極致的安全",
  "index.c6.title2": "VOOX全天候保護您的資產",
  "index.c6.1.t": "全面審計",
  "index.c6.1.p":
    "VOOX執行全面審計，確保我們平台的完整性與安全，讓每一筆交易都透明可信",
  "index.c6.2.t": "加密託管合作",
  "index.c6.2.p":
    "VOOX與頂尖的加密資產託管商合作，提升使用者資產的安全性。我們的合作是基於對最高安全標準和資產保護的承諾",
  "index.c6.3.t": "安全冷儲存",
  "index.c6.3.p":
    "VOOX使用安全的冷儲存解決方案來保護您的數位資產，最小化風險，確保您的資金免受未授權存取",
  "index.c6.4.t": "合法合規",
  "index.c6.4.p":
    "VOOX嚴格遵守法律和監管標準，確保所有操作都合法合規，為我們的用戶提供一個安全的交易環境",
  "c7.title": "無縫交易體驗",
  "c7.title2": "隨時隨地透過VOOX的手機和網頁平台訪問全球加密市場",
  c7_qrcode: "掃碼下載APP",
  c7_qrcode1: "下載 VOOX And​​roid/iOS APP",
  "c8.title": "開始您的加密貨幣之旅",
  "c8.title2": "VOOX的AI驅動洞察讓您更智慧地交易，賺取更多收益",
  "footer.contractus": "聯絡我們",
  "footer.media": "社群社媒",
  "footer.downloadapp": "下載App",
  "footer.product": "產品",
  "footer.creditCardPurchase": "快速買幣",
  "footer.c2c": "C2C買幣",
  "footer.trade": "現貨交易",
  "footer.futures": "合約交易",
  "footer.futures": "合約交易",
  "footer.koltrade": "合約跟單",
  "footer.bonus": "合約贈金",
  "footer.business": "服務",
  "footer.cms.apply": "上幣申請",
  "footer.agent.apply": "代理申請",
  "footer.c2c.apply": "C2C商家申請",
  "footer.support": "支持",
  "footer.mesage": "公告中心",
  "footer.help": "幫助中心",
  "footer.fee": "費率中心",
  "footer.about": "關於我們",
  "footer.agreement": "使用者協議",
  "footer.privacy": "隱私權政策",
  "footer.disclaimer": "反洗錢政策",
  "footer.companyname": "公司名稱: VOOX Limited",
  "footer.companynumber": "公司註冊號碼: 20241849145",
  "footer.companyaddress":
    "公司地址: 1312 17th Street, Unit Num 2955, Denver, CO 80202, United States",
  "footer.customerService": "客服中心",
  "footer.online_custom": "客服中心",
  "footer.requests": "提交工單",
  "footer.officialVerify": "官方驗證通道",
  Notice: "公告",
  "notFound.title": "404 | VOOX",
  "notFound.desc": "抱歉，您造訪的頁面不存在。",
  "notFound.backHome": "返回首頁",
};
